import { useMainStore } from 'stores/main.store'

const scrapeMenuForLinkData = function(RegionOverlayDOM) {
    const mainStore = useMainStore()

    const listItems = RegionOverlayDOM.querySelectorAll('li')
    const data = Array.from(listItems).reduce((allListItems, listItemsDOM) => {
        const linkDOM = listItemsDOM.querySelector('a')
        allListItems.push({
            href: linkDOM.href,
            displayName: linkDOM.querySelector('.be-region-overlay__menu-list-item-text').innerText.trim(),
            icon: linkDOM.querySelector('svg') ? linkDOM.querySelector('svg').outerHTML : null,
            iconAriaLabel: linkDOM.querySelector('.be-visually-hidden').innerText.trim(), 
            active: listItemsDOM.classList.contains('be-region-overlay__menu-list-item--active')
        })
        return allListItems
    }, [])
    
    mainStore.setRegionMenuData({ 
        displayName: mainStore.primaryMenuMobileData.actionsDisplayNames['region-button'].name, 
        links: data,
        order: 1,
    })
}

const el = '.be-component--region-overlay'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((RegionOverlayDOM)=>{
            scrapeMenuForLinkData(RegionOverlayDOM)
        })
    }
}

